<template>
  <div class="list-search" @keydown.esc.stop.prevent="$emit('close')">
    <div class="search-wrapper">
      <input type="text" ref="search_input" v-model="search" class="search-wrapper__search"
             :placeholder="$t('repitition.search_for') + ' '+ $t('repitition.skole')"
             @keydown.down.prevent="focusOption(0)"
             @keydown.enter.prevent="chooseFirst"/>
    </div>
    <div class="list-search__body">
      <ul>
        <li v-for="(option, index) in searchList">
          <a :href="option.url" data-no-turbolink="true" class="js-list-search-option"
             @click="chooseItem(option)"
             @keydown.down.prevent="focusOption(index + 1)"
             @keydown.up.prevent="focusOption(index - 1)"
             @keydown.home.prevent="focusOption(0)"
             @keydown.end.prevent="focusOption(searchList.length - 1)">{{ option.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'list-with-search',
  props: {
    options: {
      required: true
    }
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    searchList () {
      return this.options.filter((obj) => {
        return obj.name !== null ? obj.name.match(new RegExp(this.search, 'i')) : ''
      })
    }
  },
  methods: {
    chooseItem (obj) {
      this.$emit('choose', obj)
    },
    focusOption (index) {
      if (index < 0) {
        this.$refs.search_input.focus()
        return
      }
      const links = this.$el.querySelectorAll('.js-list-search-option')
      if (links[index]) {
        links[index].focus()
      }
    },
    chooseFirst () {
      const firstLink = this.$el.querySelector('.js-list-search-option')
      if (firstLink) {
        firstLink.click()
      }
    }
  },
  mounted () {
    this.$nextTick(_ => {
      const searchInput = this.$refs.search_input
      if (searchInput) {
        searchInput.focus()
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// ListWithSearch.vue?1032f5a2